import { useAtomValue } from 'jotai';
import {
  demoModeAtom,
  effectiveAccessRightsAtom,
  userDataAtom,
} from '@/global-store';
import {
  getGovernanceAccessLevel,
  type GovernanceArea,
} from '@/guards/governanceAccess';

export function useGovernanceAccess(area: GovernanceArea) {
  const demoMode = useAtomValue(demoModeAtom);
  const effectiveRights = useAtomValue(effectiveAccessRightsAtom);
  const user = useAtomValue(userDataAtom);
  const isPrivileged = demoMode || user?.isAdmin || user?.isSalesAdmin;
  const isLoading = !isPrivileged && effectiveRights === null;
  const accessLevel = getGovernanceAccessLevel({
    area,
    demoMode,
    effectiveRights,
    user,
  });

  return {
    accessLevel,
    canEdit: accessLevel === 'editor',
    hasAccess: accessLevel === 'viewer' || accessLevel === 'editor',
    isLoading,
  };
}
